<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div>
    <div class="page-head">
      <div>
        <h2>财务概览</h2>
        <p>查看本公司成交、应收、支出和资金概况</p>
      </div>
      <el-button
        @click="load"
        :loading="loading"
      >
        <el-icon><Refresh /></el-icon>
        刷新
      </el-button>
    </div>
    <el-row
      :gutter="16"
      class="metrics"
    >
      <el-col
        v-for="item in cards"
        :key="item.key"
        :xs="24"
        :sm="12"
        :lg="6"
      >
        <el-card shadow="never">
          <div class="metric">
            <div
              class="metric-icon"
              :class="item.color"
            >
              <el-icon><component :is="item.icon" /></el-icon>
            </div>
            <div>
              <div class="metric-label">{{ item.label }}</div>
              <div class="metric-value">¥ {{ money(summary[item.key]) }}</div>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <el-row :gutter="16">
      <el-col
        :xs="24"
        :lg="14"
      >
        <el-card
          shadow="never"
          header="待办事项"
        >
          <el-empty
            v-if="!summary.draftTransactions && !summary.pendingPayables"
            description="暂无待处理事项"
          />
          <div
            v-else
            class="todo"
          >
            <el-link
              v-if="summary.draftTransactions"
              type="primary"
              @click="$router.push('/finance/transactions')"
            >
              {{ summary.draftTransactions }} 笔成交草稿待确认
            </el-link>
            <el-link
              v-if="summary.pendingPayables"
              type="warning"
              @click="$router.push('/finance/payouts/payables')"
            >
              {{ summary.pendingPayables }} 笔员工应发待处理
            </el-link>
          </div>
        </el-card>
      </el-col>
      <el-col
        :xs="24"
        :lg="10"
      >
        <el-card
          shadow="never"
          header="财务口径"
        >
          <p class="note">
            成交确认即时形成员工应发；收款仅影响应收余额和账户现金流，不会重新计算佣金。
          </p>
          <p class="note">
            金额计算保留4位小数，结算展示2位小数，尾差计入分部公司留存。
          </p>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>
<script setup>
import { computed, onMounted, reactive, ref } from 'vue'
import { dashboardApi } from '../api'
import { ElMessage } from 'element-plus'
import { Money, Tickets, Wallet, DataAnalysis } from '@element-plus/icons-vue'
const loading = ref(false)
const summary = reactive({
  receivable: 0,
  received: 0,
  expense: 0,
  payable: 0,
  draftTransactions: 0,
  pendingPayables: 0,
})
const cards = computed(() => [
  { key: 'receivable', label: '本期应收佣金', icon: Money, color: 'red' },
  { key: 'received', label: '已确认收款', icon: Wallet, color: 'green' },
  { key: 'expense', label: '已确认支出', icon: Tickets, color: 'orange' },
  { key: 'payable', label: '员工应发', icon: DataAnalysis, color: 'blue' },
])
const money = (v) =>
  Number(v || 0).toLocaleString('zh-CN', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
const load = async () => {
  loading.value = true
  try {
    Object.assign(summary, await dashboardApi.summary())
  } catch (e) {
    ElMessage.error(e?.message || '概览加载失败')
  } finally {
    loading.value = false
  }
}
onMounted(load)
</script>
<style scoped>
.page-head {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;
}
.page-head h2 {
  font-size: 24px;
  color: #1e293b;
}
.page-head p {
  color: #8a97a8;
  margin-top: 6px;
}
.metrics {
  margin-bottom: 16px;
}
.el-card {
  margin-bottom: 16px;
  border: 0;
  border-radius: 10px;
}
.metric {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 4px;
}
.metric-icon {
  width: 42px;
  height: 42px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 21px;
}
.metric-icon.red {
  background: #fce7e7;
  color: #c22525;
}
.metric-icon.green {
  background: #dcfce7;
  color: #15803d;
}
.metric-icon.orange {
  background: #ffedd5;
  color: #c2410c;
}
.metric-icon.blue {
  background: #dbeafe;
  color: #1d4ed8;
}
.metric-label {
  font-size: 13px;
  color: #8390a2;
}
.metric-value {
  font-size: 21px;
  font-weight: 600;
  color: #1e293b;
  margin-top: 4px;
}
.todo {
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.note {
  color: #64748b;
  font-size: 13px;
  line-height: 1.8;
  margin: 6px 0;
}
</style>
